import { Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const year = new Date().getFullYear();

interface CopyrightProps {
  yearSecondLine?: boolean;
}

const Copyright = ({ yearSecondLine }: CopyrightProps) => {
  const { t } = useTranslation();

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <span>{t('footer.copyright.prefix')} </span>
      <Link color="inherit" href="https://www.arcosdorados.com/">
        {t('footer.company')}
      </Link>
      {yearSecondLine && <br />}
      <span> {t('footer.copyright.suffix', { year })}</span>
    </Typography>
  );
};

export default Copyright;
